<div class="content-section disable-auto-scroll" [ngClass]="layoutService.expandedMenu ? 'expand' : ''">
    <app-trial-license-warning></app-trial-license-warning>
    <lib-campaigns></lib-campaigns>
    <div class="title-section h-100 title-bar title-bar-nav" *ngIf=isDesktop id='title-bar'>
        <div class="title-div d-flex align-items-center">
            <div class="col p-0 d-flex justify-content-between align-items-center changeInstitution">
                <div class="p-0">
                    <a (click)="cancelSOP()">
                        <img src="assets/ph-bhp-layout/svg/back.svg" class="svg">
                        {{ 'INSTITUTION_MANAGEMENT.OVERVIEW' | translate}}
                    </a>
                    <h2 class="background_title">

                        {{ 'SOP_MANAGEMENT.EDIT_WORK_ROUTINE' | translate}}
                    </h2>
                </div>
                <div class="col-auto d-flex justify-content-md-end justify-content-sm-start">
                    <div class="col-auto institution-name pl-0">
                        <!-- <img alt="Institution" src="assets/img/svg/icon-help.svg"> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid ">
        <div class="d-flex justify-content-between" id="sopDetails" class="sopDetails sopDetails d-flex justify-content-between">
            <div class="py-2 px-4" style="width: 288px !important;">

                <!-- Title for SA / CA -->
                <div *ngIf="roleId == 1 || roleId == 2" class="bd-input mt-4" (click)="openTranslationModal(sopDetails.title, 'SOP_MANAGEMENT.SOP_TITLE')">
                    <input type="text" id="input" required="" inputSanitizer maxlength="150"
                    class="" readonly #modelSopTitle="ngModel"
                    [ngModel]="layoutService.translateText(sopDetails.title) | labelSanitizer"
                    [ngClass]="{'is-invalid':modelSopTitle.errors && (modelSopTitle.touched || modelSopTitle.dirty|| updateSubmitted)}"
                    [disabled]="blockCAChanges">
                    <label for="input" class="label" [ngClass]="sopDetails.title ? 'filled':'' " >{{'SOP_MANAGEMENT.SOP_TITLE' | translate}} </label>
                    <div class="underline"></div>
                </div>

                <!-- Title for GA / IA -->
                <div *ngIf="roleId == 3 || roleId == 4" class="bd-input mt-4">
                    <input type="text" id="input" required="" inputSanitizer maxlength="150" #modelSopTitle="ngModel"
                    [ngModel]="layoutService.translateText(sopDetails.title) | labelSanitizer" (focusout)="onFocusOutSOPInput($event, sopDetails.title)"
                    [ngClass]="{'is-invalid':modelSopTitle.errors && (modelSopTitle.touched || modelSopTitle.dirty|| updateSubmitted)}">
                    <label for="input" class="label" [ngClass]="sopDetails.title ? 'filled':'' " >{{'SOP_MANAGEMENT.SOP_TITLE' | translate}} </label>
                    <div class="underline"></div>
                </div>

                <!-- Description por SA / CA -->
                <div *ngIf="roleId == 1 || roleId == 2" class="bd-input mt-5"
                    (click)="openTranslationModal(sopDetails.description, 'CONFIGURE.DESCRIPTION', true, sopdescriptionMaxLength)">
                    <input type="text" id="inputDesc" required="" inputSanitizer maxlength="{{sopdescriptionMaxLength}}"
                    class="" readonly #modelSopDescription="ngModel"
                    [ngModel]="layoutService.translateText(sopDetails.description) | labelSanitizer"
                    [ngClass]="{'is-invalid':modelSopDescription.errors && (modelSopDescription.touched || modelSopDescription.dirty|| updateSubmitted)}"
                    [disabled]="blockCAChanges">
                    <!-- <label for="input" class="label">{{ 'CONFIGURE.DESCRIPTION' | translate }}<span class="mandatory"> *</span></label> -->
                    <label for="inputDesc" class="label" [ngClass]="sopDetails.description ? 'filled':'' ">{{ 'CONFIGURE.DESCRIPTION' | translate }}</label>
                    <div class="underline"></div>
                    <div class="form-control-descrition-msgs">
                        <span class="character-count-text">{{(sopDetails.description) ? getTranslatedKeyLength(sopDetails.description) : '0'}}
                        /
                        {{sopdescriptionMaxLength}} </span></div>
                </div>

                <!-- Description por GA / IA -->
                <div *ngIf="roleId == 3 || roleId == 4" class="bd-input mt-5">
                    <input type="text" id="inputDesc" inputSanitizer maxlength="{{sopdescriptionMaxLength}}" (focusout)="onFocusOutSOPInput($event, sopDetails.description)"
                    #modelSopDescription="ngModel" [ngModel]="layoutService.translateText(sopDetails.description) | labelSanitizer"
                    [ngClass]="{'is-invalid':modelSopDescription.errors && (modelSopDescription.touched || modelSopDescription.dirty|| updateSubmitted)}">
                    <label for="inputDesc" class="label" [ngClass]="sopDetails.description ? 'filled':'' ">{{ 'CONFIGURE.DESCRIPTION' | translate }}</label>
                    <div class="underline"></div>
                    <div class="form-control-descrition-msgs">
                        <span class="character-count-text">{{(sopDetails.description) ? getTranslatedKeyLength(sopDetails.description) : '0'}}
                        /
                        {{sopdescriptionMaxLength}} </span></div>
                </div>


            </div>
            <div class="py-2 px-4">
                <div class="card-task mb-2" [ngClass]="blockCAChanges ? 'disabled' : ''">
                    <div class="card-task-media" [ngClass]="sopImageInvalid ? 'isinvalid' : ''" (click)="editImage()">
                        <!-- <img *ngIf="!sopDetails.sopImage" class="no-image" src="assets/ph-bhp-layout/svg/no-image.png">
                        <img *ngIf="sopDetails.sopImage" class="svg img-fluid" [src]="layoutService.serverUrl+sopDetails.sopImage"> -->
                        <img [ngClass]="[sopDetails.sopImage?'svg img-fluid':'', sopDetails.isInstitutionImage?'imgFilter':'']"
                        [src]="(sopDetails.sopImage)?layoutService.serverUrl+sopDetails.sopImage:'assets/img/fallback-img.png'"
                        (error)="errImg($event)">
                    </div>
                </div>
                <div *ngIf="!blockCAChanges" class="uploadImgTxt justify-content-end mt-2 d-flex text-container-width-223">
                    <span *ngIf="sopDetails.sopImage" (click)="editImage()">{{ 'CONFIGURE.EDIT' | translate }} </span>
                    <span *ngIf="sopDetails.sopImage" (click)="openDeleteModal(delmodal);">{{ 'LAYOUT_MODULE.REMOVE' | translate }}</span>
                    <span *ngIf="!sopDetails.sopImage" (click)="editImage()">{{ 'SOP_MANAGEMENT.ADD_IMAGE' | translate }}</span>
                </div>
            </div>
        </div>
        <div id="step-list-container">

            <lib-ph-bhp-step-list (addStepAtIndexClicked)="addStep($event)" (editStepAtIndexClicked)="openStepEditor($event.stepIndex, $event.elementOffsetTop, $event.elementOffsetLeft, $event.step)" [isDesktop]="isDesktop" [sopStepsList]="sopStepsList" [blockCAChanges]="blockCAChanges"></lib-ph-bhp-step-list>

            <!-- This container is hidden by default and will be moved relative to it's parent,
       so that the popup is always below the respective list item. -->
            <div #stepEditorContainer [hidden]="lastSelectedStepIndex == null" id="step-editor-container">
                <!-- <a (click)="closeStepEditorPopup()" *ngIf='isDesktop' class="btn-close">
                    <img src="assets/ph-bhp-sopmanagement/SOP-Images/close.svg">
                </a>
                <span #stepEditorArrow class="arrow"></span> -->
                <app-step-editor [roleId]="roleId" (changeSituationalCommentForStepIndexClicked)="changeSituationalTextForSubStepIndex($event)" (changeTitleClicked)="changeStepTitle()" (changeTitleForStepIndexClicked)="changeTitleForSubStepIndex($event)" (deleteStepClicked)="deleteStep()"
                    (deleteSubStepClicked)="deleteSubStep($event)" (handDisinfectionIndicationsForStepIndexChanged)="setIndicationsForSubStepIndex($event.index, $event.value)" (hygieneRelevantForStepIndexChanged)="setHygieneRelevantForSubStepIndex($event.index, $event.value)"
                    (removeImageForStepIndexClicked)="removeImageForCurrentStepForSubStepIndex($event)" (setImageForStepIndexClicked)="setImageForCurrentStepForSubStepIndex($event)" (situationalForStepIndexChanged)="setSituationalForSubStepIndex($event.index, $event.value)"
                    (toggleSubProcessClicked)="setSubProcess($event)" (addSubStepClicked)="addSubStep()" (defaultImageIndexChanged)="setDefaultStepImage($event)" (validateCardFields)="setValidatedFields($event)" (closeStepEditor)="closeStepEditorPopup()" [step]="currentStep"
                    ></app-step-editor>
            </div>

        </div>

        <div *ngIf="roleId!=1" class="col-12 institution-selection">
            <h4 class="step-title mb-4">Institution selection</h4>
            <div class="">
                <div class="col-md-6 p-0"  institutionList.length >
                    <div class="tab-pane mt-3 fade show active">
                        <!-- <div class="d-flex justify-content-between mb-2">
                            <label>{{ translationKeys.UserProfiles.SelectInsititutions | translate }} <span class="mandatory">*</span></label>
                        </div> -->
                        <app-institution-selection [showInvalid]="!institutionIsChecked && submitted" [institutionList]="institutionList" [checkedInstitutionIds]="checkedInstitutionIdsArray" (checkedInstitutionIdsChange)="checkedInstitutionIdsChanged($event)"></app-institution-selection>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12 p-0 puzzle-comments d-flex justify-content-start" *ngIf="sopDetails.type != 'Master' || (roleId!=1 && roleId!=2)">
            <div class="row w-100">
                <div class="col-3 mb-4">
                    <div class="d-flex mx-4 align-items-center">
                        <label class="switch mr-3 d-block">
                            <input type="checkbox" id="status" name="status"
                                [(ngModel)]="IsSOPPuzzle" (change)="checkPuzzle()" [disabled]="blockCAChanges || sopDetails.type == 'Master'">
                            <span class="slider round" [ngClass]="(blockCAChanges || sopDetails.type == 'Master') ? 'disabled' : ''"></span>
                            </label>
                            <label class="puzzle-label pl-12" for="status">{{ 'SOP_MANAGEMENT.IS_PUZZLE_ENABLE' | translate }}</label>
                    </div>
                </div>

                <div class="col-3">
                    <!-- Comments for SA / CA -->
                    <div *ngIf="roleId == 1 || roleId == 2" class="bd-input mt-4" (click)="openTranslationModal(sopDetails.draftComments,  'CONFIGURE.COMMENTS', true, sopCommentsMaxLength)">
                        <input type="text" id="textComment" inputSanitizer maxlength="500"
                        class="" readonly #modelSopTitle="ngModel"
                        [ngModel]="layoutService.translateText(sopDetails.draftComments) | labelSanitizer"
                        [ngClass.class1]="{'is-invalid':modelSopTitle.errors && (modelSopTitle.touched || modelSopTitle.dirty|| updateSubmitted)}"
                        [disabled]="blockCAChanges">
                        <label for="input" class="label" [ngClass]="getTranslatedKeyLength(sopDetails.draftComments) != 0 ? 'filled' : '' " >{{'CONFIGURE.WRITE_COMMENTS_HERE' | translate}}</label>
                        <div class="underline"></div>
                    </div>

                    <!-- Comments for GA / IA-->
                    <div *ngIf="roleId == 3 || roleId == 4" class="bd-input mt-4">
                        <input type="text" id="textComment" inputSanitizer maxlength="500" (focusout)="onFocusOutSOPInput($event, sopDetails.draftComments)"
                        #modelSopTitle="ngModel" [ngModel]="layoutService.translateText(sopDetails.draftComments) | labelSanitizer"
                        [ngClass.class1]="{'is-invalid':modelSopTitle.errors && (modelSopTitle.touched || modelSopTitle.dirty|| updateSubmitted)}">
                        <label for="input" class="label" [ngClass]="getTranslatedKeyLength(sopDetails.draftComments) != 0 ? 'filled' : '' " >{{'CONFIGURE.WRITE_COMMENTS_HERE' | translate}}</label>
                        <div class="underline"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 p-0 mt-5 d-flex justify-content-end space-buttons">
            <button class="btn-cancel-bordered-bd separate-buttons" (click)="cancelSOP()">{{'BUTTON.CANCEL' | translate}}</button>
            <button class="btn btn-continue-bordered-bd separate-buttons" *ngIf="sopId" (click)="publishSOP()" >
            <span>{{ 'SOP_MANAGEMENT.PUBLISH' | translate }}</span>
            </button>
            <button (click)="PreViewSOP()" class="btn-bd-empty square"><mat-icon outline>visibility</mat-icon></button>
        </div>

        <lib-ph-bhp-sop-step #sopStepComponent [viewType]="'edit'" [userData]="userData" [institutions]="institutions" [handDisinfectionIndicators]="handDisinfectionIndicators" [sopStep]="sopStep" [subStepDisable]="isSubprocess" (childData)="childEmit($event)"
            [sopVersionNo]="sopVersionNo" [sopId]="sopId"></lib-ph-bhp-sop-step>
    </div>
</div>

<ng-template #delmodal>
    <div class="modal-header bhp-modal-header">
        <h5 class="mt-4 mb-3">{{ translationKeys.InstitutionManagement.Confirmation | translate }}</h5>
        <a (click)="modalRef.hide()" data-dismiss="modal" class="cursor"><img src="assets/ph-bhp-layout/svg/remove.svg"></a>
    </div>
    <div class="modal-body bhp-modal-body">
        <p class="">
            {{ 'SOP_MANAGEMENT.CONFIRMATION_DELETE_IMAGE' | translate }}
        </p>
    </div>
    <div class="modal-footer bhp-modal-footer">
        <button (click)="modalRef.hide()" class="btn-cancel-bordered-bd">{{ 'BUTTON.CANCEL' | translate }}</button>
        <button (click)="deleteImage();modalRef.hide()" class="btn-bd-empty">{{ 'LAYOUT_MODULE.DELETE' | translate }}</button>
    </div>

</ng-template>


<ng-template #disclaimerModal>
    <div class="mb-4 modal-header justify-content-between align-items-center">
        <h5 class="modal-title">{{ translationKeys.InstitutionManagement.Confirmation | translate }}</h5>
        <a class="cursor" data-dismiss="modal" (click)="modalRef.hide()"> <img src="assets/ph-bhp-layout/svg/remove.svg"> </a>
    </div>

    <div class="modal-body">
        <p> {{ 'SOP_MANAGEMENT.INFORMATION_LIABILITY_USER_DEFINED_SOP' | translate }} </p>
        <p>
            <input type="checkbox" [(ngModel)]="IAgree" class="custom-control-input" id="IAgree" [ngClass]="{'form-control is-invalid':modelAgree && !IAgree}">
            <label for="IAgree" required>{{ 'SOP_MANAGEMENT.AGREED' | translate }}</label>
        </p>
    </div>

    <div class="modal-footer">
        <div class="align-items-end d-flex">
            <button (click)="modalRef.hide()" class="btn-cancel-bordered-bd separate-buttons">{{ 'BUTTON.CANCEL' | translate }}</button>
            <button (click)="disclaimer();" class="btn-bd-empty">{{ 'CONFIGURE.ACCEPT' | translate }}</button>
        </div>
    </div>
</ng-template>

<ng-template #cancelmodal>
    <div class="modal-header bhp-modal-header">
        <h5 class="mt-4 mb-3">{{ translationKeys.InstitutionManagement.Confirmation | translate }}</h5>
        <a class="cursor" data-dismiss="modal" (click)="modalRef.hide()"><img src="assets/ph-bhp-layout/svg/remove.svg"></a>
    </div>
    <div class=" modal-body bhp-modal-body">
        <p class="">
            {{'INSTITUTION_MANAGEMENT.INFORMATION_UNSAVED_CHANGES_LOST_AFTER_LEAVING' | translate}}
        </p>
    </div>
    <div class="modal-footer bhp-modal-footer">
        <button (click)="modalRef.hide()" class="btn-cancel-bordered-bd">{{ 'LAYOUT_MODULE.STAY' | translate }}</button>
        <button (click)="cancelSOP();modalRef.hide()" class="btn-bd-empty ml-3">{{ 'LAYOUT_MODULE.LEAVE' | translate }}</button>
    </div>
</ng-template>
